import React from "react";
import { styles, MarjInput } from "./adminStyles";

/**
 * TL Iscilik modu render bloku
 * Tüm hesaplama backend'de yapılır, bu sadece pure form input rendering.
 */
const TlIscilikInputs = ({
  isDesktop,
  priceSource,
  tlSettings,
  handleTlChange,
}) => {
  const sectionRow = isDesktop
    ? { ...styles.section, display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }
    : styles.section;
  const sectionH3 = isDesktop
    ? { margin: 0, minWidth: '180px', fontSize: '16px', whiteSpace: 'nowrap', fontWeight: 'bold' }
    : {};

  return (
    <>
      <h2 style={{color: '#DA9F54', textAlign: 'center', marginBottom: '20px', fontSize: '18px'}}>TL Iscilik Ayarlari</h2>
      <div style={sectionRow}><h3 style={sectionH3}>Has Altin (TL)</h3><MarjInput label="Alis" marjKey="has_alis" value={tlSettings.has_alis} onChange={handleTlChange} /><MarjInput label="Satis" marjKey="has_satis" value={tlSettings.has_satis} onChange={handleTlChange} /></div>
      <div style={sectionRow}><h3 style={sectionH3}>1 Gram (TL)</h3><MarjInput label="Alis" marjKey="gram_1_alis" value={tlSettings.gram_1_alis} onChange={handleTlChange} /><MarjInput label="Satis" marjKey="gram_1_satis" value={tlSettings.gram_1_satis} onChange={handleTlChange} /></div>
      <div style={sectionRow}><h3 style={sectionH3}>5-10-20 Gram (TL)</h3><MarjInput label="Satis" marjKey="gram_5_10_20_satis" value={tlSettings.gram_5_10_20_satis} onChange={handleTlChange} /></div>
      {priceSource !== 'altinkaynak' && <div style={sectionRow}><h3 style={sectionH3}>22 Ayar (Bilezik)</h3><MarjInput label="Carpan" marjKey="bilezik_carpan" value={tlSettings.bilezik_carpan} onChange={handleTlChange} /></div>}
      <h3 style={{ color: '#DA9F54', textAlign: 'center', margin: '25px 0 15px', fontSize: '16px', borderTop: '2px solid #DA9F54', paddingTop: '20px' }}>Sarrafiye Iscilik + Marj</h3>
      <p style={{ fontSize: '12px', color: '#888', textAlign: 'center', marginBottom: '15px' }}>Formul: Sabit HAS x Canli Has Satis + Iscilik + Marj</p>
      {[
        { key: 'ceyrek', name: 'Ceyrek', sHas: 1.606, aHas: 1.596 },
        { key: 'yarim', name: 'Yarim', sHas: 3.21, aHas: 3.192 },
        { key: 'teklik', name: 'Teklik', sHas: 6.42, aHas: 6.384 },
        { key: 'ata', name: 'Ata Lira', sHas: 6.61, aHas: 6.566 },
        { key: 'gremse', name: 'Gremse', sHas: 16.06, aHas: 15.96 },
      ].map(item => {
        const k = item.key === 'ata' ? 'ata_lira' : item.key;
        return (
        <div key={item.key} style={styles.section}>
          <h3>{item.name} <span style={{fontSize: '11px', color: '#999'}}>(Satis HAS: {item.sHas} / Alis HAS: {item.aHas})</span></h3>
          <p style={{ fontWeight: 'bold', fontSize: '12px', color: '#DA9F54', margin: '8px 0 4px' }}>SATIS</p>
          <MarjInput label="Iscilik" marjKey={`${k}_iscilik`} value={tlSettings[`${k}_iscilik`]} onChange={handleTlChange} />
          <MarjInput label="Marj" marjKey={`${k}_satis_marj`} value={tlSettings[`${k}_satis_marj`]} onChange={handleTlChange} />
          <p style={{ fontWeight: 'bold', fontSize: '12px', color: '#DA9F54', margin: '12px 0 4px' }}>ALIS</p>
          <MarjInput label="Iscilik" marjKey={`${k}_alis_iscilik`} value={tlSettings[`${k}_alis_iscilik`]} onChange={handleTlChange} />
          <MarjInput label="Marj" marjKey={`${k}_alis_marj`} value={tlSettings[`${k}_alis_marj`]} onChange={handleTlChange} />
        </div>
        );
      })}
    </>
  );
};

export default TlIscilikInputs;
